export default __webpack_public_path__ + "static/media/ux.7e436987.svg";